/*
* Copyright (C) Regione Lombardia
*/
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Sorting, SortingDirectionEnum } from '@models';

@Component({
    selector: 'app-toolkit-table-sort',
    templateUrl: './table-sort.component.html',
    styleUrls: ['./table-sort.component.scss'],
})
export class SharedToolkitTableSortComponent {

    @Input() tableSortEnabled: boolean = true;
    @Input() title: string = '';
    @Input() tooltip: string = '';
    @Input() tableSortField: Sorting = {
        direction: SortingDirectionEnum.EMPTY,
        field: '',
    };
    @Input() disabled: boolean = false;

    @Output() sortTableOutput = new EventEmitter<any>();

    public cambiaDirezione() {
        this.initSortField();
        this.sortTableOutput.emit(this.tableSortField);
    }

    private initSortField() {
        switch (this.tableSortField.direction) {
            case SortingDirectionEnum.ASC:
                this.tableSortField.direction = SortingDirectionEnum.DESC;
                break;
            case SortingDirectionEnum.DESC:
                this.tableSortField.direction = SortingDirectionEnum.EMPTY;
                break;
            default:
                this.tableSortField.direction = SortingDirectionEnum.ASC;
        }
    }

}
